import { useNavigate } from 'react-router-dom';

import { useBoundStore } from 'app/store';
import { JSBarCodeGenerator } from 'features/Receipt/lib';

import './receipt.css';

export const ReceiptBarcode = () => {
  const parkingBarCodeData = useBoundStore((state) => state['medicalReceipt'].parkingBarCodeData);

  const printBarcodeText = parkingBarCodeData;
  const navigate = useNavigate();

  return (
    <div className='content-article' role='article'>
      <div className='inner-content pay-receipt-barcode'>
        {/* title */}
        <div className='title-wrap'>
          <h3>주차 바코드</h3>
          <p>주차 등록 키오스크 또는 출차소에 보여주세요.</p>
        </div>

        <div className='pay-barcode-container'>
          <div className='barcode-wrap'>
            <div>{printBarcodeText && <JSBarCodeGenerator key={`barcode`} text={printBarcodeText} />}</div>
          </div>
        </div>
      </div>

      <div className='btm-content'>
        <button type='button' className='btn_n btn_primary' onClick={() => navigate('/receipt')}>
          돌아가기
        </button>
      </div>
    </div>
  );
};
